import { render, staticRenderFns } from "./MobileLanguages.vue?vue&type=template&id=04c20b52&scoped=true&"
import script from "./MobileLanguages.vue?vue&type=script&lang=js&"
export * from "./MobileLanguages.vue?vue&type=script&lang=js&"
import style0 from "./MobileLanguages.vue?vue&type=style&index=0&id=04c20b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c20b52",
  null
  
)

export default component.exports